// src/components/MainMenuBar.js
// "Main Applications Menu" button: back to the NGC Operations hub
// (ops.nxtgc.com). Sits just above the bottom menu, clear of the raised
// SCAN button, full width of the page content.
import React, { useLayoutEffect, useState } from 'react';

export const MAIN_MENU_URL = process.env.REACT_APP_MAIN_MENU_URL || 'https://ops.nxtgc.com';
const GAP = 10;       // space between this button and the top of the SCAN button
const BAR_HEIGHT = 46; // about how tall the button renders
const PAGE_BOTTOM_PADDING = 80; // .screen-content already leaves this much for the bottom menu

// Distance from the bottom of the window to just above the highest part of
// the bottom menu (the SCAN circle pokes up above the menu bar).
function clearance() {
  const tops = ['.bottom-nav', '.scan-circle']
    .map((sel) => document.querySelector(sel))
    .filter(Boolean)
    .map((el) => el.getBoundingClientRect().top);
  if (!tops.length) return 96;
  return Math.max(0, Math.round(window.innerHeight - Math.min(...tops))) + GAP;
}

export default function MainMenuBar() {
  const [bottom, setBottom] = useState(96);

  useLayoutEffect(() => {
    const update = () => setBottom(clearance());
    update();
    const t = setTimeout(update, 300); // after fonts/icons settle
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
    return () => {
      clearTimeout(t);
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
    };
  }, []);

  return (
    <>
      {/* Extra room at the end of the page so its own content can always be
          scrolled clear of this button (the page already leaves room for
          the bottom menu itself). */}
      <div aria-hidden="true" style={{ height: Math.max(0, bottom + BAR_HEIGHT + 8 - PAGE_BOTTOM_PADDING), flexShrink: 0 }} />
      <a className="main-menu-bar" href={MAIN_MENU_URL} style={{ bottom }}>
        <img className="main-menu-bar-logo" src="/ngc-logo.png" alt="Next Generation" />
        <span className="main-menu-bar-label">Main Applications Menu</span>
      </a>
    </>
  );
}
